export class RevenueDetailsByCategoryDetails {
    categoryName: string | number;
    subCategoryName: string | number;
    tdyActualRevenue: string | number;
    tdyLastYearRevenue: string | number;
    mtdActual: string | number;
    mtdLastYear: string | number;
    ytdActual: string | number;
    ytdLastYear: string | number;
    tdyVob: string | number;
    mtdVob: string | number;
    ytdVob: string | number;
    tdyVoly: string | number;
    ytdVoly: string | number;
    uom:string | number;
    todayBudget: string | number;
    mtd_budget: string | number;
    ytd_budget: string | number;
}